<template>
  <div class="text-left">
    <div
      class="flex gap-2 items-center mb-2 cursor-pointer"
      @click="expand = !expand"
    >
      <h3>{{ name }}</h3>
      <svg
        class="h-3.5 w-3.5"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
      >
        <path
          v-if="expand"
          d="M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"
        />
        <path
          v-else
          d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"
        />
      </svg>
    </div>
    <Transition name="slide">
      <div
        v-if="expand"
        :class="[type === 'image' ? 'flex flex-wrap gap-2' : '']"
      >
        <div v-for="item in items" :key="name + item.name">
          <img
            v-if="type === 'image'"
            class="rounded-md overflow-hidden cursor-pointer"
            @click="handleChange(item.name)"
            :class="
              lowerCaseSelections?.includes(item.name.toLowerCase())
                ? 'ring-2 ring-offset-1 ring-beige'
                : ''
            "
            :src="
              item.image?.length
                ? item.image
                : `https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8bikI-KUuM1IWosgqDRS5jyv2U_PPYlG6Tg&s`
            "
            height="50"
            width="50"
          />

          <div v-if="type === 'checkbox'" class="flex gap-2 items-center">
            <div class="inline-flex items-center">
              <label
                class="relative flex items-center px-1 py-2 rounded-full cursor-pointer"
                :htmlFor="'cb_' + item.name"
              >
                <input
                  type="checkbox"
                  class="before:content[''] peer relative h-5 w-5 cursor-pointer appearance-none border border-blue-gray-200 transition-all before:absolute before:top-2/4 before:left-2/4 before:block before:h-12 before:w-12 before:-translate-y-2/4 before:-translate-x-2/4 before:rounded-full before:bg-blue-gray-500 before:opacity-0 before:transition-opacity checked:border-beige checked:bg-beige checked:before:bg-beige hover:before:opacity-10"
                  :id="'cb_' + item.name"
                  :checked="
                    lowerCaseSelections?.includes(item.name.toLowerCase())
                  "
                  @change="$emit('select', { group: name, item: item.name })"
                />
                <span
                  class="absolute text-white transition-opacity opacity-0 pointer-events-none top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 peer-checked:opacity-100"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-3.5 w-3.5"
                    viewBox="0 0 20 20"
                    fill="white"
                    stroke="white"
                    stroke-width="1"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </span>
              </label>
            </div>
            <label
              :for="'cb_' + item.name"
              class="ms-2 font-medium cursor-pointer"
            >
              {{ item.name }}
            </label>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "FilterGroup",
  props: {
    expanded: Boolean,
    name: String,
    type: {
      type: String,
      default: "image",
    },
    items: {
      type: Array,
      default: () => [],
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
  created(){
    this.expand = !!this.expanded;
  },
  emit: ["select"],
  data() {
    return {
      expand: false,
    };
  },
  computed: {
    lowerCaseSelections() {
      return this.selectedItems.map((i) => i.toLowerCase());
    },
  },
};
</script>

<style>
.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in-out;
  -webkit-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
}

.slide-enter-to,
.slide-leave {
  max-height: 400px;
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
